import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary capturó:", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="error-boundary-fallback" style={{
        minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
        background: "linear-gradient(135deg,#faf5ff,#fdf2f8)", fontFamily: "Arial,Helvetica,sans-serif", padding: 16,
      }}>
        <div style={{ background: "#fff", borderRadius: 24, boxShadow: "0 20px 50px rgba(124,58,237,.15)", padding: 40, maxWidth: 440, textAlign: "center" }}>
          <div style={{
            width: 56, height: 56, borderRadius: 16, margin: "0 auto 16px",
            background: "linear-gradient(90deg,#8B5CF6,#EC4899)", display: "flex", alignItems: "center", justifyContent: "center",
            color: "#fff", fontSize: 26, fontWeight: 700,
          }}>!</div>
          <h1 style={{ fontSize: 20, color: "#1f2937", margin: "0 0 8px" }}>Algo salió mal</h1>
          <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 20px", lineHeight: 1.6 }}>
            Ha ocurrido un error inesperado en ViralTubeAI. Recarga la aplicación para continuar.
          </p>
          {this.state.error && (
            <p style={{ fontSize: 11, color: "#9ca3af", background: "#f9fafb", borderRadius: 8, padding: 10, margin: "0 0 20px", wordBreak: "break-word" }}>
              {String(this.state.error?.message || this.state.error).slice(0, 200)}
            </p>
          )}
          <button
            data-testid="error-boundary-reload"
            onClick={() => { window.location.href = "/"; }}
            style={{
              background: "linear-gradient(90deg,#8B5CF6,#EC4899)", color: "#fff", border: 0,
              borderRadius: 12, padding: "12px 28px", fontSize: 14, fontWeight: 700, cursor: "pointer",
            }}
          >
            Recargar la aplicación
          </button>
        </div>
      </div>
    );
  }
}
